import { Link } from 'react-router-dom';
import { CATEGORIES, SITE } from '@/config/site';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-accent-200 bg-accent-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-background-50">
                <i className="ri-chat-smile-3-fill" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{SITE.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">{SITE.intro}</p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-base text-primary-600" />
              <a href={`mailto:${SITE.email}`} className="cursor-pointer hover:text-primary-600">
                {SITE.email}
              </a>
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">站内导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="cursor-pointer text-foreground-600 hover:text-primary-600">首页</Link></li>
              <li><Link to="/topics" className="cursor-pointer text-foreground-600 hover:text-primary-600">话题广场</Link></li>
              <li><Link to="/about" className="cursor-pointer text-foreground-600 hover:text-primary-600">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">话题分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {CATEGORIES.slice(0, 4).map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/topics?category=${c.name}`}
                    className="cursor-pointer text-foreground-600 hover:text-primary-600"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-accent-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {SITE.name} · 本站内容为网络公开讨论的整理与观察，仅供交流参考</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="cursor-pointer hover:text-primary-600">内容原则</Link>
            <Link to="/about" className="cursor-pointer hover:text-primary-600">免责声明</Link>
            <a href={`mailto:${SITE.contactEmail}`} className="cursor-pointer hover:text-primary-600">合作联系</a>
          </div>
        </div>
      </div>
    </footer>
  );
}